// TODO move to lib

import { configureAuth } from 'react-query-auth';

import { getUser } from '@/features/auth/api/get-user';
import { login } from '@/features/auth/api/login';
import { logout } from '@/features/auth/api/logout';
import { register } from '@/features/auth/api/register';
import { LoginInput } from '@/features/auth/validation/login-input.schema';
import { RegisterInput } from '@/features/auth/validation/register-input.schema';

const authConfig = {
  userFn: async () => {
    try {
      const user = await getUser();
      return user;
    } catch {
      return null;
    }
  },
  loginFn: async (loginInput: LoginInput) => {
    const { user } = await login(loginInput);
    return user;
  },
  registerFn: async (registerInput: RegisterInput) => {
    const { user } = await register(registerInput);
    return user;
  },
  logoutFn: logout,
};

export const reactQueryAuth = configureAuth(authConfig);
